import tokenHttpClient from "../utils/httpClient";
import { post } from "../utils/httpClient-methods";
import { BRAND_LIST_API_URL, BASE_URL_MASTERS } from "../utils/AppApiUrl";

export const BrandListingService = async (requestBody) => {
  try {
    const brandListingRequestObj = {
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      filterSearch: requestBody?.filterSearch ?? null,
      active: requestBody?.active,
      sortBy: requestBody?.sortBy,
      sortDirection: requestBody?.sortDirection,
    };
    const brandListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.brandListing}`,
      brandListingRequestObj
    );
    // add condition here to check
    if (brandListingResponse.status === 200) {
      // const { data } = brandListingResponse;
      return brandListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const BrandListingSearchService = async (requestBody, searchValue) => {
  try {
    const brandListingRequestObj = {
      active: requestBody?.active,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      filterSearch: searchValue,
      sortBy: "brandName",
      sortDirection: "ASC",
    };
    const brandListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.brandListing}`,
      brandListingRequestObj
    );
    // add condition here to check
    if (brandListingResponse.status === 200) {
      // const { data } = brandListingResponse;
      return brandListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const onAddProductCategoryService = async (values) => {
  try {
    const requestBody = {
      categoryCode: values?.categoryCode ?? "",
      categoryName: values?.categoryName ?? "",
      categoryId: values?.categoryId ?? null,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: values?.modifiedOn ?? null,
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      active: values?.active,
    };
    const saveCategoryDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.saveProductCategoryDetails}`,
      requestBody
    );
    if (saveCategoryDetails.status === 200) {
      return saveCategoryDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const onUpdateProductCategoryService = async (values) => {
  try {
    const requestBody = {
      categoryCode: values?.categoryCode ?? "",
      categoryName: values?.categoryName ?? "",
      categoryId: values?.categoryId ?? null,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: new Date(),
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      active: values?.active,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.updateProductCategoryDetails}`,
      requestBody
    );
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const categoryListingService = async (values) => {
  try {
    const categoryListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.categoryListing}`,
      values
    );
    // add condition here to check
    if (categoryListingResponse.status === 200) {
      // const { data } = categoryListingResponse;
      return categoryListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const categoryListingSearchService = async (
  requestBody,
  searchValue
) => {
  try {
    const categoryListingRequestObj = {
      active: requestBody?.active,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      filterSearch: searchValue,
      sortBy: "categoryName",
      sortDirection: "ASC",
    };
    const categoryListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.categoryListing}`,
      categoryListingRequestObj
    );
    // add condition here to check
    if (categoryListingResponse.status === 200) {
      // const { data } = categoryListingResponse;
      return categoryListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const onAddProductBrickService = async (values) => {
  try {
    const requestBody = {
      productFamilyId: values?.productFamilyId ?? "",
      brickName: values?.brickName ?? "",
      brickId: values?.brickId ?? 0,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: values?.modifiedOn ?? null,
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      active: values?.active,
      brickCode : values?.brickCode
    };
    const saveBrickDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.saveProductBrickDetails}`,
      requestBody
    );
    if (saveBrickDetails.status === 200) {
      return saveBrickDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const onEditProductBrickService = async (values) => {
  try {
    const requestBody = {
      productFamilyId: values?.productFamilyId ?? "",
      brickName: values?.brickName ?? "",
      brickId: values?.brickId ?? 0,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: new Date(),
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      active: values?.active,
      brickCode : values?.brickCode
    };
    const updateBrickDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.updateProductBrickDetails}`,
      requestBody
    );
    if (updateBrickDetails.status === 200) {
      return updateBrickDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const onAddProductFamilyService = async (values) => {
  try {
    const requestBody = {
      categoryId: values?.categoryId ?? null,
      categoryName: values?.categoryName ?? null,
      productFamilyId: values?.productFamilyId ?? null,
      productFamilyName: values?.productFamilyName ?? null,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: values?.modifiedOn ?? null,
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      active: values?.active ?? true,
    };
    const saveProductFamilyDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.saveProductFamilyDetails}`,
      requestBody
    );
    if (saveProductFamilyDetails.status === 200) {
      return saveProductFamilyDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const onUpdateProductFamilyService = async (values) => {
  try {
    const requestBody = {
      categoryId: values?.categoryId ?? null,
      categoryName: values?.categoryName ?? null,
      productFamilyId: values?.productFamilyId ?? 0,
      productFamilyName: values?.productFamilyName ?? null,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: new Date(),
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      active: values?.active,
      productCatFamilyMappingId: values?.productCatFamilyMappingId,
    };
    const saveProductFamilyDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.updateProductFamilyDetails}`,
      requestBody
    );
    if (saveProductFamilyDetails.status === 200) {
      return saveProductFamilyDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const FamilyListingService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.getFamilyListingWithOrWithoutCategory}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      // const { data } = response;
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const FamilyListingSearchService = async (requestBody, searchValue) => {
  try {
    const familyListingRequestObj = {
      active: requestBody?.active,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      filterSearch: searchValue,
      categoryId: requestBody?.id ?? null,
      sortBy: "productFamilyName",
      sortDirection: "ASC",
    };
    const familyListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.getFamilyListingWithOrWithoutCategory}`,
      familyListingRequestObj
    );
    // add condition here to check
    if (familyListingResponse.status === 200) {
      // const { data } = familyListingResponse;
      return familyListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const AllBrandListingService = async () => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.getAllBrandsListing}`,
      null
    );
    // add condition here to check
    if (response.status === 200) {
      // const { data } = response;
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const BrickListingWithOrWithoutFamilyId = async (requestBody) => {
  try {
    const brickListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.getBrickListOnSelectedFamily}`,
      requestBody
    );
    // add condition here to check
    if (brickListingResponse.status === 200) {
      // const { data } = brickListingResponse;
      return brickListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const BrickListingWithOrWithoutFamilyIdSearchService = async (
  requestBody,
  searchValue
) => {
  try {
    const brickListingObject = {
      active: requestBody?.active,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      filterSearch: searchValue,
      sortDirection: "ASC",
      sortBy: "brickName",
      productFamilyId: null,
    };
    const brickListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.getBrickListOnSelectedFamily}`,
      brickListingObject
    );
    // add condition here to check
    if (brickListingResponse.status === 200) {
      // const { data } = brickListingResponse;
      return brickListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const onAddBrandService = async (values) => {
  try {
    const requestBody = {
      brandName: values?.brandName ?? "",
      categoryName: values?.categoryName ?? "",
      categoryId: values?.categoryId ?? null,
      brickName: values?.brickName ?? "",
      brickId: values?.brickId ?? "",
      brandId: values?.brandId ?? null,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: values?.modifiedOn ?? null,
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      productFamilyName: values?.productFamilyName ?? "",
      productFamilyId: values?.productFamilyId ?? 0,
      active: values?.active,
    };
    const saveBrandDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.saveBrandDetails}`,
      requestBody
    );
    if (saveBrandDetails.status === 200) {
      return saveBrandDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const onUpdateBrandService = async (values, mappingId) => {
  try {
    const requestBody = {
      brandName: values?.brandName ?? "",
      categoryName: values?.categoryName ?? "",
      categoryId: values?.categoryId ?? null,
      brickName: values?.brickName ?? "",
      brickId: values?.brickId ?? "",
      brandId: values?.brandId ?? null,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: new Date(),
      createdOn: values?.createdOn,
      createdBy: values?.createdBy ?? 1,
      active: values?.active,
      productFamilyName: values?.productFamilyName ?? "",
      productFamilyId: values?.productFamilyId ?? 0,
      mappingId,
    };
    const updateBrandDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.updateBrandDetails}`,
      requestBody
    );
    if (updateBrandDetails.status === 200) {
      return updateBrandDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const BrandChangeStatusService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.changeBrandStatus}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ChangeBrandBrickMappingStatusService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.changeBrandBrickMappingStatus}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      // const { data } = response;
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const CategoryChangeStatusService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.changeProductCategoryStatus}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      // const { data } = response;
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ProductFamilyChangeStatusService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.changeProductFamilyStatus}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      // const { data } = response;
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ProductBrickChangeStatusService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.changeProductBrickStatus}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      // const { data } = response;
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
